import apiClient from './client'

export interface ContactMessage {
  name: string
  email: string
  message: string
  website: string // honeypot, always sent empty by real users
  elapsed_ms: number // ms the form was on screen before submit
}

export interface QuoteRequest {
  product: string
  grade: string
  quantity: string
  address: string
  company: string
  vat: string
  email: string
  message: string
  website: string // honeypot, always sent empty by real users
  elapsed_ms: number // ms the form was on screen before submit
}

export async function sendMessage(payload: ContactMessage): Promise<void> {
  await apiClient.post('/contact/message', payload)
}

export async function sendQuoteRequest(payload: QuoteRequest): Promise<void> {
  await apiClient.post('/contact/quote', payload)
}
